import type { OptionValue } from '@ui-kit/components/formComponents/Select/types'

export const getOptionIdentifier = (value: OptionValue, name: string) =>
  `${name}-select-option-${value}`
